import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getAppRoutesArray } from './app-routes';
import { where } from '../framework/utils/collection';
import { usePageManager } from '../services/page-manager';
import { BwjViewManager } from '../framework/components/bwj-view-manager';
import { xlationContext } from '../framework/utils/i18n';
import { ResourceNotFoundPage } from './presentation/pages/z-not-found';
import { useStandardErrorState } from '../entities/view-manager-standard/error';

xlationContext('Wrapper that verifies access to pages')

export const AppPages: React.FunctionComponent = () => {
  const viewState = usePageManager();
  const errorState = useStandardErrorState();
  const topLevelRoutes = where(getAppRoutesArray(), route => route.topLevel);

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{ message: '' }}
      errorState={errorState}
      customState={{}} // blank screen.  If not here, custom state is rendered as error screen
    >
      <Switch>
        {topLevelRoutes.map(route => <Route key={route.key} path={route.urlTemplate} exact={route.exact} component={route.component} />)}
        <Route path={'*'} component={ResourceNotFoundPage} />
      </Switch>
    </BwjViewManager>
  );
};
